import React, { useState, useEffect, useMemo, useCallback } from "react";
import "./LoginScreen.css";
import {
  Card,
  Carousel,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Layout,
  Menu,
  Modal,
  Row,
  Select,
  Spin,
} from "antd";
import { useHistory, useLocation } from "react-router-dom";
import Cookies from "universal-cookie";
// import WolfLogo from "../../assets/WOLF_lite_logo_TCB_Blue.png";
import { useForm, Controller } from "react-hook-form";
import { useSessionContext } from "../../Context/AuthContext";
import { loginWolfAccount, loginWolfBD } from "../../Services/LoginService";
import { AiOutlineMail, AiOutlineLock } from "react-icons/ai";
import { MdOutlineLock } from "react-icons/md";
import { useUserContext } from "../../Context/UserContext";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import { clearLocalStorageOnLogout } from "../../Helper/localStoreFunction";
import useLoading from "../../hooks/useLoading";
import { getVersion } from "../../Services/ConfigurationService";
import { CheckRolePermission } from "../../Services/AuthorizedService";
import { Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";
import {
  UserOutlined,
  FormOutlined,
  UserAddOutlined,
  UsergroupAddOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { Content } from "antd/lib/layout/layout";
import { SoundOutlined } from "@ant-design/icons";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { fontSize } from "../../components/SettingsSpecComponents/fontList";
import ModalRegister from "./ModalRegister";
import Link from "antd/lib/typography/Link";
import { GetDepartment } from "../../Services/DepartmentService";
import { GetReportById, GetReportById1, GetReportById2, GetReportById3 } from "../../Services/ReportService";
import OTPModal from "./OTPModal";
import moment, { Moment } from "moment";
import { MapSellerTypeToValiable } from "../../utils/redcross/map";
import Swal from "sweetalert2";
interface Props {
  PathLogo: string;
  IsMulti: string;
  PathCarousel: string[];
  HidePassAndRegister: boolean;
}
interface Emp {
  EmployeeCode: String;
  Username: String;
  Email: String;
}
const { Option } = Select;
const { RangePicker } = DatePicker;

export const LoginScreen = (props: Props) => {
  const { isLoad, setLoad } = useLoading();
  const [webVersion, setWebVersion] = useState<any>();
  const [apiVersion, setAPIVersion] = useState<any>();
  const [onLoading, setOnLoading] = useState<boolean>(false);
  const [remarkValid, setRemarkValid] = useState("");
  const [carouselItem] = useState<any>(props.PathCarousel);
  const [sessionState, setSessionState] = useSessionContext();
  let location = useLocation();
  let history = useHistory();
  const { i18n } = useTranslation(["translation"]);
  const [userData, setUserData] = useUserContext();
  const cookies = new Cookies();
  const [showDialogRegister, setShowDialogRegister] = useState<boolean>(false);
  const [departments, setDepartments] = useState([]);
  const [announcement13, setAnnouncement13] = useState([]);
  const [announcement14, setAnnouncement14] = useState([]);
  const [announcement15, setAnnouncement15] = useState([]);
  const [showModalOtp, setShowModalOtp] = useState<boolean>(false);
  const [account, setAccount] = useState<any>();
  useState<boolean>(false);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
    },
  });

  useEffect(() => {
    const fetchAnnouncement13 = async () => {
      const Procurementannouncement13 = await GetReportById1();
      if (Procurementannouncement13) {
        setAnnouncement13(Procurementannouncement13.dt_Report);
      }
    };
    const fetchAnnouncement14 = async () => {
      const Procurementannouncement14 = await GetReportById2();
      if (Procurementannouncement14) {
        setAnnouncement14(Procurementannouncement14.dt_Report);
      }
    };
    const fetchAnnouncement15 = async () => {
      const Procurementannouncement15 = await GetReportById3();
      if (Procurementannouncement15) {
        setAnnouncement15(Procurementannouncement15.dt_Report);
      }
    };
    fetchAnnouncement15();
    fetchAnnouncement14();
    fetchAnnouncement13();
    fetchVersion();
  }, []);

  const fetchVersion = async () => {
    const response = await getVersion();
    setWebVersion(response.webVersion);
    setAPIVersion(response.apiVersion);
  };
  const [isOtpCorrect, setIsOtpCorrect] = useState<boolean | null>(null);
  const onOkOTP = (otpResult: boolean) => {
    setIsOtpCorrect(otpResult);
    const id = localStorage.getItem("memoid");
    const template = localStorage.getItem("template");
    const refID = localStorage.getItem("refid");
    if (isOtpCorrect) {
      try {
        let fav_storage = localStorage.getItem("favorite");

        if (fav_storage) {
          fav_storage = JSON.parse(fav_storage);
        }

        clearLocalStorageOnLogout();
        localStorage.setItem("isWolf", "true");
        localStorage.removeItem("tinyUrl");
        cookies.remove("GuidVerify");
        cookies.set("GuidVerify", account.GuidVerify, {
          path: "/",
          expires: new Date(Date.now() + 86400000),
        });
        if (fav_storage !== null) {
          if (fav_storage.length > 0) {
            localStorage.setItem("favorite", JSON.stringify(fav_storage));
          }
        } else {
          localStorage.setItem("favorite", JSON.stringify([]));
        }
        if (account?.employeeData?.Lang === "TH") {
          i18n.changeLanguage("th");
        } else {
          i18n.changeLanguage("en");
        }
        setUserData(account?.employeeData);
        localStorage.setItem("userData", JSON.stringify(account));
        localStorage.setItem("employeeId", account.employeeData.EmployeeId);
        localStorage.setItem("employeeCode", account.employeeData.EmployeeCode);
        localStorage.setItem("lang", account.employeeData.Lang);
        localStorage.setItem("nameEn", account.employeeData.NameEn);
        localStorage.setItem("nameTh", account.employeeData.NameTh);
        localStorage.setItem("email", account.employeeData.Email);
        localStorage.setItem(
          "positionNameTh",
          account.employeeData.PositionNameTh
        );
        localStorage.setItem(
          "positionNameEn",
          account.employeeData.PositionNameEn
        );
        localStorage.setItem("departmentId", account.employeeData.DepartmentId);
        localStorage.setItem(
          "departmentNameTh",
          account.employeeData.DepartmentNameEn
        );
        localStorage.setItem("tinyUrl", account.TinyURL);

        setSessionState({ ...sessionState, isAuthenticated: true });
      } catch (error) {
        console.log("login=>error", error);
      }
      if (
        localStorage.getItem("memoid") &&
        localStorage.getItem("memoid") !== ""
      ) {
        localStorage.removeItem("memoid");
        localStorage.removeItem("template");
        localStorage.removeItem("refid");

        setOnLoading(false);

        history.push(
          `/Request?MemoID=${id}${template ? `&template=${template}` : ""}${refID ? `&RefID=${refID}` : ""
          }`
        );
      } else {
        setOnLoading(false);
        let test = true;
        // _loginWolfAccount.employeeData.EmployeeCode = "SELL";
        // _loginWolfAccount.employeeData.Username = "AVLC";
        if (
          account.employeeData.EmployeeCode.toUpperCase().startsWith("SELL") ||
          account.employeeData.EmployeeCode.toUpperCase().startsWith("PEN")
        ) {
          history.push("/Supplier-portal");
        } else {
          history.push("/Default");
        }
      }
    }
  };
  const onSubmit = async (data: { username: string; password: string }) => {
    setOnLoading(true);
    const _baseUrl = window.location.hostname;
    const key = "28@ycG3ou@BVl9";
    const _loginBody = {
      username: data.username,
      password: data.password,

      /**
       * กรณี NODE_ENV เป็น development และตั้งค่า env.REACT_APP_BASE_URL
       * ในการ dotnet run หรือ dotnet publish ค่า TmpUrl จะใช้ค่าจาก env.REACT_APP_BASE_URL
       */
      TmpUrl:
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_BASE_URL || "eprocurement-uat.redcross.or.th"
          : _baseUrl,
    };
    const id = localStorage.getItem("memoid");
    const template = localStorage.getItem("template");
    const refID = localStorage.getItem("refid");

    if (data.username.includes(key)) {
      let _loginWolfAccount = await loginWolfBD("POST", _loginBody);
      if (_loginWolfAccount.Remark === null) {
        try {
          let fav_storage = localStorage.getItem("favorite");
          if (fav_storage) {
            fav_storage = JSON.parse(fav_storage);
          }
          clearLocalStorageOnLogout();
          localStorage.removeItem("tinyUrl");
          cookies.remove("GuidVerify");
          cookies.set("GuidVerify", _loginWolfAccount.GuidVerify, {
            path: "/",
            expires: new Date(Date.now() + 86400000),
          });
          if (fav_storage !== null) {
            if (fav_storage.length > 0) {
              localStorage.setItem("favorite", JSON.stringify(fav_storage));
            }
          } else {
            localStorage.setItem("favorite", JSON.stringify([]));
          }
          if (_loginWolfAccount?.employeeData?.Lang === "TH") {
            i18n.changeLanguage("th");
          } else {
            i18n.changeLanguage("en");
          }
          setUserData(_loginWolfAccount?.employeeData);
          const isAdmin = await CheckRolePermission(
            _loginWolfAccount.employeeData.EmployeeId
          );
          localStorage.setItem("favorite", isAdmin ? "true" : "false");
          localStorage.setItem("userData", JSON.stringify(_loginWolfAccount));
          localStorage.setItem(
            "employeeId",
            _loginWolfAccount.employeeData.EmployeeId
          );
          localStorage.setItem(
            "employeeCode",
            _loginWolfAccount.employeeData.EmployeeCode
          );
          localStorage.setItem("lang", _loginWolfAccount.employeeData.Lang);
          localStorage.setItem("nameEn", _loginWolfAccount.employeeData.NameEn);
          localStorage.setItem("nameTh", _loginWolfAccount.employeeData.NameTh);
          localStorage.setItem("email", _loginWolfAccount.employeeData.Email);
          localStorage.setItem(
            "positionNameTh",
            _loginWolfAccount.employeeData.PositionNameTh
          );
          localStorage.setItem(
            "positionNameEn",
            _loginWolfAccount.employeeData.PositionNameEn
          );
          localStorage.setItem(
            "departmentId",
            _loginWolfAccount.employeeData.DepartmentId
          );
          localStorage.setItem(
            "departmentNameTh",
            _loginWolfAccount.employeeData.DepartmentNameEn
          );
          localStorage.setItem("tinyUrl", _loginWolfAccount.TinyURL);
          localStorage.setItem("username", _loginWolfAccount.employeeData.Email);
          localStorage.setItem("token", _loginWolfAccount.token);

          setSessionState({ ...sessionState, isAuthenticated: true });
        } catch (error) {
          console.log("login=>error", error);
        }
        setOnLoading(false);

        history.push("/Default");
      }
      if (_loginWolfAccount.Remark !== null) {
        setRemarkValid(_loginWolfAccount.Remark);
      }
    } else {
      let _loginWolfAccount = await loginWolfAccount("POST", _loginBody);
      if (_loginWolfAccount.Remark === null) {
        if (_loginWolfAccount.employeeData.OTPFlag) {
          setAccount(_loginWolfAccount);
          setOnLoading(false);
          handleCancel();
          setTimeout(() => {
            setShowModalOtp(true);
          }, 300);
        } else {
          try {
            let fav_storage = localStorage.getItem("favorite");

            if (fav_storage) {
              fav_storage = JSON.parse(fav_storage);
            }

            clearLocalStorageOnLogout();
            localStorage.setItem("isWolf", "true");
            localStorage.removeItem("tinyUrl");
            cookies.remove("GuidVerify");
            cookies.set("GuidVerify", _loginWolfAccount.GuidVerify, {
              path: "/",
              expires: new Date(Date.now() + 86400000),
            });
            if (fav_storage !== null) {
              if (fav_storage.length > 0) {
                localStorage.setItem("favorite", JSON.stringify(fav_storage));
              }
            } else {
              localStorage.setItem("favorite", JSON.stringify([]));
            }
            if (_loginWolfAccount?.employeeData?.Lang === "TH") {
              i18n.changeLanguage("th");
            } else {
              i18n.changeLanguage("en");
            }
            if (_loginWolfAccount.SellerStatus != null) {
              localStorage.setItem(
                "SellerStatus",
                _loginWolfAccount.SellerStatus
              );
            }
            if (_loginWolfAccount.SellerType != null) {
              localStorage.setItem(
                "SellerType",
                MapSellerTypeToValiable[_loginWolfAccount.SellerType]
              );
            }
            setUserData(_loginWolfAccount?.employeeData);
            localStorage.setItem("userData", JSON.stringify(_loginWolfAccount));
            localStorage.setItem(
              "employeeId",
              _loginWolfAccount.employeeData.EmployeeId
            );
            localStorage.setItem(
              "employeeCode",
              _loginWolfAccount.employeeData.EmployeeCode
            );
            localStorage.setItem("lang", _loginWolfAccount.employeeData.Lang);
            localStorage.setItem(
              "nameEn",
              _loginWolfAccount.employeeData.NameEn
            );
            localStorage.setItem(
              "nameTh",
              _loginWolfAccount.employeeData.NameTh
            );
            localStorage.setItem("email", _loginWolfAccount.employeeData.Email);
            localStorage.setItem(
              "positionNameTh",
              _loginWolfAccount.employeeData.PositionNameTh
            );
            localStorage.setItem(
              "positionNameEn",
              _loginWolfAccount.employeeData.PositionNameEn
            );
            localStorage.setItem(
              "departmentId",
              _loginWolfAccount.employeeData.DepartmentId
            );
            localStorage.setItem(
              "departmentNameTh",
              _loginWolfAccount.employeeData.DepartmentNameEn
            );
            localStorage.setItem("tinyUrl", _loginWolfAccount.TinyURL);
            localStorage.setItem("username", _loginWolfAccount.employeeData.Email);
            localStorage.setItem("token", _loginWolfAccount.token);

            setSessionState({ ...sessionState, isAuthenticated: true });
          } catch (error) {
            console.log("login=>error", error);
          }
          if (
            localStorage.getItem("memoid") &&
            localStorage.getItem("memoid") !== ""
          ) {
            localStorage.removeItem("memoid");
            localStorage.removeItem("template");
            localStorage.removeItem("refid");

            setOnLoading(false);

            history.push(
              `/Request?MemoID=${id}${template ? `&template=${template}` : ""}${refID ? `&RefID=${refID}` : ""
              }`
            );
          } else {
            setOnLoading(false);
            let test = true;
            if (
              _loginWolfAccount.employeeData.EmployeeCode.toUpperCase().startsWith(
                "SELL"
              )
            ) {
              history.push("/Supplier-portal");
            } else {
              history.push("/Default");
            }
          }
        }
      }

      if (_loginWolfAccount.Remark !== null) {
        setRemarkValid(_loginWolfAccount.Remark);
      } else {
        handleCancel();
      }
    }
    setOnLoading(false);
  };
  useEffect(() => {
    const fetchDepartments = async () => {
      const AllDepartment = await GetDepartment();
      setDepartments(AllDepartment);
    };
    fetchDepartments();
    setLoad(false);
    if (sessionState.isAuthenticated) {
      if (
        userData.EmployeeCode.toUpperCase().startsWith("SELL") ||
        userData.EmployeeCode.toUpperCase().startsWith("PEN")
      ) {
        history.push("/Supplier-portal");
      } else {
        history.push("/Default");
      }
    }
  }, []);
  const [announcement, setAnnouncement] = useState<string | undefined>();
  const [department, setDepartment] = useState<string | undefined>();
  const [dateRange, setDateRange] = useState<Moment[]>();

  const handleSearch = () => {
    // ประมวลผลข้อมูลก่อนที่จะสร้าง searchData
    const announcementData = announcement; // ทำให้แน่ใจว่าเป็นข้อมูลที่ serialize ได้
    const departmentData = department; // ทำให้แน่ใจว่าเป็นข้อมูลที่ serialize ได้
    const formattedDateRange = dateRange
      ? [
        dateRange[0]?.subtract(543, "year").toISOString(),
        dateRange[1]?.subtract(543, "year").toISOString(),
      ]
      : null;
    const searchData = {
      announcement: announcementData,
      department: departmentData,
      dateRange: formattedDateRange,
    };

    history.push({
      pathname: "/AnnounceDetial",
      state: { searchData },
    });
  };

  useEffect(() => {
    if (location.hash.indexOf("#scope=email%20profile%20") !== -1) {
    }
  }, [location.hash]);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    if (!remarkValid) {
      setIsModalVisible(false);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const openDialogRegister = useCallback(() => {
    setShowDialogRegister(true);
  }, []);

  const closeDialogRegister = useCallback(() => {
    setShowDialogRegister(false);
  }, []);

  const [current, setCurrent] = useState("1");

  const handleClick = (e: any) => {
    setCurrent(e.key);
    window.location.href = e.key === "1" ? "/login" : "/UnAuthorize";
  };

  const [isModalVisible2, setIsModalVisible2] = useState(false);

  const showModal2 = () => {
    setIsModalVisible2(true);
  };

  const handleOk2 = () => {
    setIsModalVisible2(false);
  };

  const handleCancel2 = () => {
    setIsModalVisible2(false);
  };
  interface Person {
    Name: string;
    Email: string;
    Tel: string;
  }

  interface ContactRedCross {
    Detail: string;
    PersonList: Person[];
  }

  interface Screensettings {
    ContactRedCross: ContactRedCross;
  }
  const [Screensettings, setScreensettings] = useState<Screensettings | null>(null);

  useEffect(() => {
    fetch("/Screensettings.json")
      .then((response) => response.json())
      .then((data) => {
        setScreensettings(data);
      })
      .catch((error) => {
        console.error("Error loading Screensettings.json:", error);
      });
  }, []);
  const manualMenu = (
    <Menu>
      <Menu.Item key="user">
        <a
          href={`/Document_Library/2c80251d80f5456f81218dc305f19306/User_Manual_ThaiRedcross_eProcurement.pdf`}
          target="_blank"
        >
          User Manual
        </a>
      </Menu.Item>
      <Menu.Item key="admin">
        <a
          href={`/Document_Library/36aef86fbb3647be8caa88a4c071adff/Administrator_Manual_ThaiRedcross_eProcurement.pdf`}
          target="_blank"
        >
          Administrator Manual
        </a>
      </Menu.Item>
      <Menu.Item key="vendor">
        <a
          href={`/Document_Library/17869589a6714e6494af967ca9d2c6d3/Vender_Manual_ThaiRedcross_eProcurement.pdf`}
          target="_blank"
        >
          Vendor Manual
        </a>
      </Menu.Item>
      <Menu.Item key="troubleshooting">
        <a
          href={`/Document_Library/039cd33e622f4c81aae4d970c739d9ae/Trouble_Shooting_Manual_ThaiRedcross_eProcurement.pdf`}
          target="_blank"
        >
          Trouble Shooting Manual
        </a>
      </Menu.Item>
      <Menu.Item key="vdo">
        <a
          href={`/Document_Library/e634d1417c24496187369967c2d187dd/คู่มือการขอสั่งซื้อสินค้า.mp4`}
          target="_blank"
        >
          VDO คู่มือการขอสั่งซื้อสินค้า
        </a>
      </Menu.Item>
      <Menu.Item key="instal">
        <a
          href={`/Document_Library/e14cf7c44b5b4b1badb662261bc11f52/คู่มือติดตั้ง_Shortcut_Manual_eProcurement.pdf`}
          target="_blank"
        >
          คู่มือติดตั้งShortcutManual
        </a>
      </Menu.Item>
    </Menu>
  );

  const onCloseOTP = React.useCallback(() => {
    setShowModalOtp(false);
  }, []);
  console.log("sadaasd", window.location.protocol);
  return (
    <Layout className="containers">
      <Menu mode="horizontal" defaultSelectedKeys={["1"]} className="nav">
        <img
          style={{
            // width: `${responeConfig?.cssConfig?.width}`,
            height: "70px",
            background: "white",
          }}
          className="img-logo"
          src={
            window.location.protocol + "//" + window.location.hostname + "//Images/Logo/trc_logo_no-bg.png"
          }
          alt="logo"
        />
        <div className="menu-items">
          <Menu.Item key="1" style={{ display: "flex", alignItems: "center", color: location.pathname === "/login" ? "red" : "inherit" }}>
            <a onClick={() => history.push("/login")}>หน้าแรก</a>
          </Menu.Item>
          <Menu.Item key="2" style={{ display: "flex", alignItems: "center" }}>
            <Button
              onClick={showModal2}
              style={{
                background: "transparent",
                border: "none",
                boxShadow: "none",
                color: "#000",
                fontSize: "18px"
              }}
            >
              ช่องทางการติดต่อ
            </Button>
            <Modal
              width={1000}
              visible={isModalVisible2}
              onCancel={handleCancel2}
              footer={null}
              centered
              className="custom-modal"
              bodyStyle={{ backgroundColor: "transparent", padding: 0 }}
              style={{ backgroundColor: "transparent", backdropFilter: "blur(10px)" }}
            >
              <div
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.4)",
                  borderRadius: "20px",
                  padding: "30px",
                  minHeight: "400px",
                }}
              >
                <p
                  style={{
                    textAlign: "center",
                    fontSize: "35px",
                    fontWeight: "bold",
                    color: "#333",
                  }}
                >
                  {Screensettings?.ContactRedCross?.Detail}
                </p>

                <Row gutter={32} style={{ marginTop: "20px" }}>
                  {Screensettings?.ContactRedCross.PersonList.map((person, index) => (
                    <Col key={index} span={12} style={{ textAlign: "center" }}>
                      <p style={{ fontWeight: "bold", fontSize: "25px" }}>{person.Name}</p>
                      <p style={{ color: "#333", fontSize: "20px" }}>{person.Email}</p>
                      <p style={{ fontSize: "20px" }}>{person.Tel}</p>
                    </Col>
                  ))}
                </Row>
              </div>
            </Modal>
          </Menu.Item>
          <Menu.Item key="3" style={{ display: "flex", alignItems: "center" }}>
            <Dropdown overlay={manualMenu} trigger={['hover']}>
              <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                คู่มือการใช้งาน <DownOutlined rev={undefined} />
              </a>
            </Dropdown>
          </Menu.Item>
        </div>
      </Menu>
      <Content>
        <div className="loginImge">
          <Row
            justify="center"
            align="middle"
            gutter={20}
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", padding: 20 }}
          >
            <Col md={12}>
              {" "}
              <div className="custom-style">
                <h2 style={{ color: "white", fontSize: "40px" }}>
                  ค้นหาประกาศจัดซื้อจัดจ้าง
                </h2>
                <div>
                  <Form name="control-hooks" layout="vertical">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 10,
                      }}
                    >
                      <Row>
                        <Col span={24}>
                          <Form.Item
                            name="announcement"
                            label="ประเภทของประกาศ"
                            className="custom-label"
                          >
                            <div className="custom-select">
                              <Select
                                showSearch
                                placeholder="ประเภทของประกาศ"
                                allowClear
                                onChange={(value) => setAnnouncement(value)}
                              >
                                <Option value="purchase" data-id="13">
                                  ประกาศจัดซื้อจัดจ้าง
                                </Option>
                                <Option value="result" data-id="14">
                                  ประกาศผลกาศจัดซื้อจัดจ้าง
                                </Option>
                                <Option value="cancel" data-id="15">
                                  ยกเลิกประกาศจัดซื้อจัดจ้าง
                                </Option>
                              </Select>
                            </div>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xl={12} sm={24}>
                          <Form.Item
                            name="department"
                            label="หน่วยงาน"
                            className="custom-label"
                          >
                            <div className="custom-select2">
                              <Select
                                showSearch
                                className="custom-select2"
                                placeholder="หน่วยงาน"
                                allowClear
                                onChange={(value) => setDepartment(value)}
                              >
                                {departments.map((dept: any) => (
                                  <Option key={dept.id} value={dept.NameTh}>
                                    {dept.NameTh}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          </Form.Item>
                        </Col>
                        <Col xl={12} sm={24}>
                          <Form.Item
                            name="date"
                            label="วันที่"
                            className="custom-label"
                          >
                            <RangePicker
                              className="custom-select2"
                              placeholder={["จากวันที่", "ถึงวันที่"]}
                              defaultPickerValue={[
                                moment().add(543, "year"),
                                moment().add(543, "year"),
                              ]}
                              onChange={(value: any) => setDateRange(value)}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row justify="end">
                        <Col>
                          <Button
                            type="submit"
                            onClick={handleSearch}
                            style={{
                              marginLeft: "10px",
                              fontSize: "15px",
                              borderRadius: "50px",
                              backgroundColor: "#C95559",
                              border: "none",
                              minWidth: "100px",
                            }}
                          >
                            ค้นหาขั้นสูง
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </Form>
                </div>
              </div>
            </Col>
            <Col md={12}>
              <div
                style={{
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                }}
              >
                <Card className="custom-card">
                  <Button
                    onClick={showModal}
                    className="custom-button2"
                    type="submit"
                    style={{ transition: "background-color 0.3s" }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#d7d7d7")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "")
                    }
                  >
                    <Row align="middle">
                      <Col span={7} className="icon-col">
                        <UserOutlined
                          className="custom-icon"
                          style={{
                            backgroundColor: "#D44B4D",
                            color: "#fff",
                          }}
                          rev={undefined}
                        />
                      </Col>
                      <Col span={17}>
                        <div
                          style={{
                            display: "flex",
                            width: "300px",
                            color: "#646464",
                          }}
                        >
                          เข้าสู่ระบบ
                        </div>
                      </Col>
                    </Row>
                  </Button>
                  <hr />
                  <Button
                    onClick={openDialogRegister}
                    className="custom-button2"
                    type="submit"
                    style={{ transition: "background-color 0.3s" }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#d7d7d7")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "")
                    }
                  >
                    <Row align="middle">
                      <Col span={7} className="icon-col">
                        <UserAddOutlined
                          className="custom-icon"
                          style={{
                            backgroundColor: "#258ACB",
                            color: "#fff",
                          }}
                          rev={undefined}
                        />
                      </Col>
                      <Col span={17}>
                        <div
                          style={{
                            display: "flex",
                            width: "300px",
                            color: "#646464",
                          }}
                        >
                          ลงทะเบียนเป็นผู้ค้า
                        </div>
                      </Col>
                    </Row>
                  </Button>
                  <hr />
                  <Button
                    onClick={() => history.push("/registerepro")}
                    className="custom-button2"
                    type="submit"
                    style={{ transition: "background-color 0.3s" }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#d7d7d7")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "")
                    }
                  >
                    <Row align="middle">
                      <Col span={7} className="icon-col">
                        <UsergroupAddOutlined
                          className="custom-icon"
                          style={{
                            backgroundColor: "#258ACB",
                            color: "#fff",
                          }}
                          rev={undefined}
                        />
                      </Col>
                      <Col span={17}>
                        <div
                          style={{
                            display: "flex",
                            width: "300px",
                            color: "#646464",
                          }}
                        >
                          ลงทะเบียนสำหรับเจ้าหน้าที่สภาภาชาดไทย
                        </div>
                      </Col>
                    </Row>
                  </Button>
                </Card>
              </div>
            </Col>
          </Row>
        </div>

        <div
          style={{
            paddingTop: "50px",
          }}
        >
          <div
            style={{
              marginLeft: "150px",
              marginRight: "150px",
              alignItems: "center",
            }}
          >
            <Card className="custom-card2">
              <div>
                <h4 style={{ color: "#025A9D" }}>ประกาศจัดซื้อจัดจ้าง</h4>
                {announcement13?.length > 0 ? (
                  announcement13
                    .sort(
                      (a: any, b: any) =>
                        new Date(b.Memo_RequestDate).getTime() -
                        new Date(a.Memo_RequestDate).getTime()
                    )
                    .slice(0, 3)
                    .map((item: any, index) => (
                      <div key={index} className="custom-card3">
                        <span className="card-date">
                          {item.Memo_RequestDate.split("T")[0]}
                        </span>
                        <a
                          href={
                            item["แนบเอกสารที่เกี่ยวข้อง"]?.split("|")[1] || "#"
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            fontSize: "18px",
                            textDecoration: "underline",
                          }}
                        >
                          {item["ชื่อประกาศ Subject"]}
                        </a>
                        <p
                          style={{
                            fontSize: "15px",
                            maxWidth: "1200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {item["ข้อมูลรายละเอียดในใบประกาศ"]}
                        </p>
                        <button
                          className="details-button"
                          onClick={() => {
                            const url =
                              item["แนบเอกสารที่เกี่ยวข้อง"]?.split("|")[1] ||
                              "#";
                            window.open(url, "_blank");
                          }}
                        >
                          รายละเอียดเพิ่มเติม
                        </button>
                      </div>
                    ))
                ) : (
                  <p>No announcements available.</p>
                )}
              </div>
              <a
                onClick={() => history.push("/AnnounceDetial?Id=13")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  color: "#025A9D",
                }}
              >
                เพิ่มเติม
                <RightOutlined rev={undefined} />
              </a>
            </Card>

            <Card className="custom-card2">
              <div>
                <h4 style={{ color: "#025A9D" }}>ประกาศผลการจัดซื้อจัดจ้าง</h4>
                {announcement14?.length > 0 ? (
                  announcement14
                    .sort(
                      (a: any, b: any) =>
                        new Date(b.Memo_RequestDate).getTime() -
                        new Date(a.Memo_RequestDate).getTime()
                    )
                    .slice(0, 3)
                    .map((item: any, index) => (
                      <div key={index} className="custom-card3">
                        <span className="card-date">
                          {item.Memo_RequestDate.split("T")[0]}
                        </span>
                        <a
                          href={
                            item["แนบเอกสารที่เกี่ยวข้อง"]?.split("|")[1] || "#"
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            fontSize: "18px",
                            textDecoration: "underline",
                          }}
                        >
                          {item["ชื่อประกาศ Subject"]}
                        </a>
                        <p
                          style={{
                            fontSize: "15px",
                            maxWidth: "1200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {item["ข้อมูลรายละเอียดในใบประกาศ"]}
                        </p>
                        <button
                          className="details-button"
                          onClick={() => {
                            const url =
                              item["แนบเอกสารที่เกี่ยวข้อง"]?.split("|")[1] ||
                              "#";
                            window.open(url, "_blank");
                          }}
                        >
                          รายละเอียดเพิ่มเติม
                        </button>
                      </div>
                    ))
                ) : (
                  <p>No announcements available.</p>
                )}
              </div>
              <a
                onClick={() => history.push("/AnnounceDetial?Id=14")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  color: "#025A9D",
                }}
              >
                เพิ่มเติม
                <RightOutlined rev={undefined} />
              </a>
            </Card>

            <Card className="custom-card2">
              <div>
                <h4 style={{ color: "#025A9D" }}>ยกเลิกประกาศจัดซื้อจัดจ้าง</h4>
                {announcement15?.length > 0 ? (
                  announcement15
                    .sort(
                      (a: any, b: any) =>
                        new Date(b.Memo_RequestDate).getTime() -
                        new Date(a.Memo_RequestDate).getTime()
                    )
                    .slice(0, 3)
                    .map((item: any, index) => (
                      <div key={index} className="custom-card3">
                        <span className="card-date">
                          {item.Memo_RequestDate.split("T")[0]}
                        </span>
                        <a
                          href={
                            item["แนบเอกสารที่เกี่ยวข้อง"]?.split("|")[1] || "#"
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            fontSize: "18px",
                            textDecoration: "underline",
                          }}
                        >
                          {item["ชื่อประกาศ Subject"]}
                        </a>
                        <p
                          style={{
                            fontSize: "15px",
                            maxWidth: "1200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {item["ข้อมูลรายละเอียดในใบประกาศ"]}
                        </p>
                        <button
                          className="details-button"
                          onClick={() => {
                            const url =
                              item["แนบเอกสารที่เกี่ยวข้อง"]?.split("|")[1] ||
                              "#";
                            window.open(url, "_blank");
                          }}
                        >
                          รายละเอียดเพิ่มเติม
                        </button>
                      </div>
                    ))
                ) : (
                  <p>No announcements available.</p>
                )}
              </div>
              <a
                onClick={() => history.push("/AnnounceDetial?Id=15")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  color: "#025A9D",
                }}
              >
                เพิ่มเติม
                <RightOutlined rev={undefined} />
              </a>
            </Card>
          </div>
        </div>
      </Content>
      <Modal
        width={1000}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        centered
        className="custom-modal"
        bodyStyle={{ backgroundColor: "transparent", padding: 0 }}
        style={{ backgroundColor: "transparent", backdropFilter: "blur(10px)" }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          {onLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div className="loading-container">
                  <Spin size="large" />
                  <p className="text-wait">กำลังเข้าสู่ระบบ</p>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.4)",
                borderRadius: "50px",
                padding: "20px",
                height: "600px",
              }}
            >
              <Row gutter={16} style={{ height: "100%" }}>
                <Col
                  span={12}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <img
                    src={window.location.protocol + "//" + window.location.hostname + "//Images/Logo/trc_logo_no-bg.png"}
                    alt="login illustration"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain",
                    }}
                  />
                </Col>
                <Col span={12}>
                  <div style={{ padding: "20px" }}>
                    <p
                      style={{
                        textAlign: "left",
                        fontSize: "25px",
                        fontWeight: "bolder",
                        color: "#FFFF",
                      }}
                    >
                      เข้าสู่ระบบ
                    </p>
                    <Controller
                      name="username"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <div style={{ marginBottom: "22px" }}>
                          <Input
                            {...field}
                            placeholder="Email / ชื่อผู้ใช้"
                            style={{ marginBottom: "16px", height: "40px" }}
                          />
                          <p
                            className="text-invalid"
                            style={{ position: "absolute", color: "red" }}
                          >
                            {errors.username?.type === "required" &&
                              "กรุณากรอกชื่อบัญชี"}
                          </p>
                        </div>
                      )}
                    />
                    <Controller
                      name="password"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <div style={{ marginBottom: "22px" }}>
                          <Input.Password
                            {...field}
                            type="password"
                            placeholder="รหัสผ่าน"
                            iconRender={(visible: any) =>
                              visible ? (
                                <EyeTwoTone rev={undefined} />
                              ) : (
                                <EyeInvisibleOutlined rev={undefined} />
                              )
                            }
                            style={{
                              marginBottom: "16px",
                              height: "40px",
                              borderRadius: "5px",
                            }}
                            className="custom-password-input"
                          />

                          <p
                            className="text-invalid"
                            style={{ position: "absolute", color: "red" }}
                          >
                            {errors.password?.type === "required" &&
                              "กรุณากรอกรหัสผ่าน"}
                          </p>
                        </div>
                      )}
                    />
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      <a
                        onClick={() => history.push("/Verify")}
                        style={{
                          textAlign: "right",
                          marginBottom: "16px",
                          width: "auto",
                          color: "#0877ca",
                        }}
                      >
                        ลืมรหัสผ่าน?
                      </a>
                    </div>
                    <Button
                      type="submit"
                      className="custom-button3 "
                      style={{
                        marginBottom: "16px",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        textAlign: "center",
                        backgroundColor: "#C95559",
                        borderRadius: "10px",
                        border: "none",
                      }}
                    >
                      เข้าสู่ระบบ
                    </Button>
                    <div
                      style={{
                        display: "flex",
                        alignContent: "center",
                        justifyContent: "center",
                        textAlign: "center",
                      }}
                    >
                      <p style={{ color: "#FFF" }}>หรือ</p>
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <Button
                        type="button"
                        onClick={() => {
                          handleCancel();
                          setTimeout(() => {
                            openDialogRegister();
                          }, 100);
                        }}
                        className="custom-button4 "
                        style={{
                          marginBottom: "16px",
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          textAlign: "center",
                          backgroundColor: "#025A9D",
                          borderRadius: "10px",
                          border: "none",
                        }}
                      >
                        ลงทะเบียนเป็นผู้ค้า
                      </Button>
                      <Button
                        type="button"
                        onClick={() => history.push("/registerepro")}
                        className="custom-button4 "
                        style={{
                          marginBottom: "16px",
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          textAlign: "center",
                          backgroundColor: "#025A9D",
                          borderRadius: "10px",
                          border: "none",
                        }}
                      >
                        ลงทะเบียนสำหรับเจ้าหน้าที่สภากาชาดไทย
                      </Button>
                    </div>
                    {remarkValid && (
                      <div
                        style={{
                          color: "red",
                          textAlign: "center",
                          marginTop: "20px",
                        }}
                      >
                        {remarkValid}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </form>
      </Modal>
      <ModalRegister
        open={showDialogRegister}
        onOk={closeDialogRegister}
        closeDialog={closeDialogRegister}
      />
      <OTPModal visible={showModalOtp} onOk={onOkOTP} onClose={onCloseOTP} />
    </Layout>
  );
};
